import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import {DialogClose} from './DialogFrame/DialogClose';
import {messageConfig} from '../../constants/messages';

type Props = {
  track_name: string;
  track_artist: string;
  handleOk: () => void;
  onCancel: () => void;
};
const DialogConfirmRequestSong = ({
  track_name,
  track_artist,
  onCancel,
  handleOk,
}: Props) => {
  return (
    <Dialog maxWidth='sm' fullWidth open>
      <DialogTitle>
        <Typography>Request A Song</Typography>
        <DialogClose onClose={onCancel} />
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableRow>
            <TableCell className='w-200 text-white-50'>
              <Typography aria-level={2} variant='subtitle1'>
                Song Title
              </Typography>
            </TableCell>
            <TableCell>
              <Typography aria-level={2} variant='h6'>
                {track_name}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className='w-200 text-white-50'>
              <Typography aria-level={2} variant='subtitle1'>
                Artist Name
              </Typography>
            </TableCell>
            <TableCell>
              <Typography aria-level={2} variant='h6'>
                {track_artist}
              </Typography>
            </TableCell>
          </TableRow>
        </Table>

        <Typography
          aria-level={2}
          className='text-center'
          marginBottom={1}
          marginTop={2}
          variant='h6'>
          {messageConfig.receivedSong.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color='primary' variant='contained' onClick={handleOk}>
          Ok
        </Button>
        <Button color='primary' variant='outlined' onClick={onCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmRequestSong;
